exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user-profile .card[data-v-85c9c5fc]{\n    min-height: 190px;\n}\n", ""]);

// exports
